import { createRouter, createWebHistory } from "vue-router";

import { firebaseUser, waitForFirebaseAuth } from "./lib/firebase";
import { useAdminSession } from "./lib/session";
import LoginView from "./views/LoginView.vue";
import OrderDetailView from "./views/OrderDetailView.vue";
import OrdersView from "./views/OrdersView.vue";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "login", component: LoginView },
    { path: "/", redirect: "/orders" },
    { path: "/orders", name: "orders", component: OrdersView, meta: { requiresAdmin: true } },
    {
      path: "/orders/:orderId",
      name: "order-detail",
      component: OrderDetailView,
      meta: { requiresAdmin: true }
    },
    { path: "/:pathMatch(.*)*", redirect: "/orders" }
  ],
  scrollBehavior: () => ({ top: 0 })
});

router.beforeEach(async (to) => {
  if (to.name === "login" && !firebaseUser.value) return true;
  await waitForFirebaseAuth();
  const session = useAdminSession();
  if (to.meta.requiresAdmin) {
    if (!firebaseUser.value) return { name: "login", query: { redirect: to.fullPath } };
    try {
      await session.loadSession();
    } catch {
      return { name: "login" };
    }
  }
  if (to.name === "login" && firebaseUser.value) {
    try {
      await session.loadSession();
      return { name: "orders" };
    } catch {
      return true;
    }
  }
  return true;
});
